import { Component } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ThemePalette } from "@angular/material/core";
import { MatTableDataSource } from "@angular/material/table";
import {
  DateTimeAdapter,
  OWL_DATE_TIME_FORMATS,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from "@danielmoncada/angular-datetime-picker";
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { PaginationInstance } from "ngx-pagination";
import { MY_OWL_FORMATS } from "src/app/model/owl_date";
import { CommonService } from "src/app/services/common/common.service";
import { GlobalService } from "src/app/services/global/global.service";
import { SharedModule } from "src/app/shared/shared.module";
import { AddCategoryComponent } from "../add-category/add-category.component";
import { MatDialog } from "@angular/material/dialog";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { AppService } from "src/app/services/app/app.service";
import { PositiveNumber } from "src/app/model/positive_number";
import { DatePipe } from "@angular/common";
import { id } from "date-fns/locale";
import { DeleteItemComponent } from "../../delete-item/delete-item.component";
import { RecruiterService } from "src/app/services/recruiter/recruiter.service";
import { TimeSetting } from "src/app/model/settings";
import { RulesService } from "src/app/services/rules/rules.service";
import { CreateDressCodeComponent } from "../create-dress-code/create-dress-code.component";
// u_t:1 for the manage legal compliance
//u_t:0 for the young worker's visa rules
enum UserType {
  company = "company",
  recruiter = "recruiter",
}
enum WageType {
  defaultCompany = "def_com",
  defaultEmployee = "def_emp",
  specificCompany = "spe_com",
  specificEmployee = "spe_emp",
}
interface OvertimeWeekDays {
  daily_overtime: string[];
  partial_day_overtime: string[];
  premium_time: string[];
  night_premium: [];
  consecutive_days_overtime: string[];
}

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
  standalone: true,
  imports: [SharedModule, NgbPaginationModule, NgxMaterialTimepickerModule],
  providers: [
    // {provide: DateTimeAdapter, useClass: OwlNativeDateTimeModule},
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_OWL_FORMATS },
  ],
})
export class SettingsComponent {
  dateFormat = MY_OWL_FORMATS;
  public settingsArr: any[] = [
    { name: "Visa", icon: "fa-cog", id: 0, u_typ: ["company", "recruiter"] },
    // { name: "Pay Rates", icon: "fa-cog", id: 1, u_typ: ['company', 'recruiter'] },
    {
      name: "Invoicing Rates for Company",
      icon: "fa-cog",
      id: 2,
      u_typ: ["recruiter"],
    },
    {
      name: "Employee Pay Rates",
      icon: "fa-cog",
      id: 3,
      u_typ: ["company", "recruiter"],
    },
    {
      name: "Premium Time",
      icon: "fa-cog",
      id: 4,
      u_typ: ["company", "recruiter"],
    },
    {
      name: "Manage Dresscode",
      icon: "fa-cog",
      id: 5,
      u_typ: ["company", "recruiter"],
    },
    // {name:"Team Member",icon:"fa-cog"},
    // {name:"Notifications",icon:"fa-cog"},
  ];
  public visaDateArr: any[] = [{ d_h: "", s_dt: "", e_dt: "" }];
  public condIds1: any = "";
  public condIds0: any = "";
  public ids1: any = "";
  public ids0: any = "";
  public selectedSetting: any;
  public visaForm!: FormGroup;
  public displayedColumns: string[] = ["title", "created_at", "action"];
  public displayedDressColumns: string[] = ["dress", "action"];
  public dataSource = new MatTableDataSource();
  public dressCode = new MatTableDataSource();
  public count!: any;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize;
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public searchInput: string = "";
  private previousInputValue: string = "";
  public youngVisaForm!: FormGroup;
  public userType!: string;
  public wageType!: string;

  public filterObjData = {
    dresscode: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 1,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
  };

  public weekdaysArr: any[] = [
    { name: "Sunday", abb: "S", val: "sun" },
    { name: "Monday", abb: "M", val: "mon" },
    { name: "Tuesday", abb: "T", val: "tue" },
    { name: "Wednesday", abb: "W", val: "wed" },
    { name: "Thursday", abb: "T", val: "thur" },
    { name: "Friday", abb: "F", val: "fri" },
    { name: "Saturday", abb: "S", val: "sat" },
  ];
  public multiplier: string = "multiply";

  public timeSetting: TimeSetting = {
    premiumTime: {
      selectedDays: [],
      default: false,
      custom: "",
      selectedMonth: [],
    },
    weeklyOt: {
      isEnabled: "",
      startsAfter: "",
      wageType: "multiply",
      wages: "",
    },
    nightPremium: {
      isEnabled: "",
      wageType: "multiply",
      wages: "",
      betweenStart: "",
      betweenEnd: "",
    },
    daily: {
      isEnabled: "",
      selectedDays: [],
      startsAfter: "",
      wageType: "multiply",
      wages: "",
      selectedMonth: [],
    },
    partial: {
      isEnabled: "",
      selectedDays: [],
      startsAfter: "",
      wageType: "multiply",
      wages: "",
    },
    payPeriod: {
      isEnabled: "",
      startsAfter: "",
      wageType: "multiply",
      wages: "",
      selectedMonth: [],
    },
  };
  public breakType: string = "disable_breaks"
  public remDays = [
    { label: "S", value: "sun", selected: false, },
    { label: "M", value: "mon", selected: false, },
    { label: "T", value: "tues", selected: false, },
    { label: "W", value: "wed", selected: false, },
    { label: "T", value: "thur", selected: false, },
    { label: "F", value: "fri", selected: false, },
    { label: "S", value: "sat", selected: false, },
  ];
  public limitationArr = [
    { key: "custom_limit_by_day_sun", "fr": "", "to": "", "sun": "1", val: "S", selected: false },
    { key: "custom_limit_by_day_mon", "fr": "", "to": "", "mon": "1", val: "M", selected: false },
    { key: "custom_limit_by_day_tues", "fr": "", "to": "", "tues": "1", val: "T", selected: false },
    { key: "custom_limit_by_day_wed", "fr": "", "to": "", "wed": "1", val: "W", selected: false },
    { key: "custom_limit_by_day_thur", "fr": "", "to": "", "thur": "1", val: "T", selected: false },
    { key: "custom_limit_by_day_fri", "fr": "", "to": "", "fri": "1", val: "F", selected: false },
    { key: "custom_limit_by_day_sat", "fr": "", "to": "", "sat": "1", val: "S", selected: false },
  ]
  public workdays = [
    { label: "S", value: "sun", selected: false, hours: "8" },
    { label: "M", value: "mon", selected: false, hours: "8" },
    { label: "T", value: "tues", selected: false, hours: "8" },
    { label: "W", value: "wed", selected: false, hours: "8" },
    { label: "T", value: "thur", selected: false, hours: "8" },
    { label: "F", value: "fri", selected: false, hours: "8" },
    { label: "S", value: "sat", selected: false, hours: "8" },
  ];
  public overtimeWeekDays: OvertimeWeekDays = {
    daily_overtime: [],
    premium_time: [],
    night_premium: [],
    partial_day_overtime: [],
    consecutive_days_overtime: [],
  }
  public automaticArr: any[] = [
    { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "1" }
  ];
  public generalObj = {
    "default_work_hour": { "fr": "10:00", "to": "10:00" },
    daily_limit_exceed: { "value": "5", selected: false, "hmd": "1", "af_bf": "0", },
    auto_clock_out_hour: { "hmd": "1", "af_bf": "0", "value": "10", selected: false },
    show_pay_rates: { "yes_no": "1", selected: false },
    timesheet_rounding: { yes_no: "1", value: "2", selected: false },
    payroll_cycle: { hmd: "3", value: "" },
    timesheet_approval: { "yes_no": "1", selected: false },
    "timesheet_review_user": { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "09:00", selected: false, oth_text: "Please review your work hours in the timesheet!" },
    "timesheet_review_admin": { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "09:00", selected: false, oth_text: "It is time to review your employees' timesheets" },
    // Reminders 
    "reminder_active_on": this.getRemArray(this.remDays),
    "employee_clockin_at": { "value": "10", selected: false },
    "employee_clockout_at": { "value": "20", selected: false },
    // Notification object
    "add_new_shift": { "mobile": false, "push": "", "email": false },
    "edit_shift": { "mobile": "1", "push": "", "email": "" },
    "exceed_work_hour": { "mobile": "1", "push": "", "email": "" },
    "auto_clock_out": { "mobile": "1", "push": "", "email": "" },
    "request_pending_approval": { "mobile": "1", "push": "", "email": "", "value": "" },
    "submitted_timesheet": { "mobile": "1", "push": "", "email": "" },
    "app_disapp_job": { "mobile": "1", "push": "", "email": "" },
    //Limitation object
    "clock_in_limitation": { "cl_li": "1", "value": "15", "hmd": "1", "af_bf": "0", selected: false },
    "auto_clockout_time": { "cl_li": "1", "value": "15", "hmd": "1", "af_bf": "0", selected: false },
    // geolocation
    "geolocation": { track: '1' },
    //breaks
    "manual_breaks": { "yes_no": "0", selected: false },
    "automatic_breaks": this.automaticArr,
    "disable_breaks": { "yes_no": "0", selected: false },
    //overtime
    "weekly_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    "daily_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    "pay_period_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    //limitation custom limit by days
    "custom_limit_by_day_sun": { "fr": "", "to": "", "sun": "1", val: "S", selected: false },
    "custom_limit_by_day_mon": { "fr": "", "to": "", "mon": "1", val: "M", selected: false },
    "custom_limit_by_day_tues": { "fr": "", "to": "", "tues": "1", val: "T", selected: false },
    "custom_limit_by_day_wed": { "fr": "", "to": "", "wed": "1", val: "W", selected: false },
    "custom_limit_by_day_thur": { "fr": "", "to": "", "thur": "1", val: "T", selected: false },
    "custom_limit_by_day_fri": { "fr": "", "to": "", "fri": "1", val: "F", selected: false },
    "custom_limit_by_day_sat": { "fr": "", "to": "", "sat": "1", val: "S", selected: false },
    "premium_time": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    "night_premium": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "fr": "21", "to": "7", "s_m": 1, "s_mv": "2.6" },
    "partial_day_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6", "fr": "8", "to": "11" },
    "consecutive_days_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6", "st_on": "7" },


  }
  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private dialog: MatDialog,
    private appService: AppService,
    private datePipe: DatePipe,
    private recruiterService: RecruiterService,
    private commonservice: CommonService,
    private rulesService: RulesService,

  ) { }
  ngOnInit(): void {
    this.commonService.setTitle("Settings");
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.selectedSetting = this.settingsArr[0];
    this.getVisaAPI();
    this.visaForm = this.fb.group({
      d_h: ["", Validators.required],
      dates: this.fb.array([]),
    });
    this.youngVisaForm = this.fb.group(
      {
        age: ["", [Validators.required, PositiveNumber]],
        d_h: ["", [Validators.required, PositiveNumber]],
        dates: this.fb.array([]),
      }
      // {validator: positiveNumber('d_h')}
    );
    this.addYoungVisaDates()
    // this.getCategoryList();
    let userData = JSON.parse(
      this.appService.getData("training-portal.userInfo")
    );
    if (userData.group_type == "company" && userData.u_typ == 1) {
      this.userType = UserType.recruiter;
      this.settingsArr = this.settingsArr.filter((setting) =>
        setting.u_typ.includes("recruiter")
      );
    } else {
      this.settingsArr = this.settingsArr.filter((setting) =>
        setting.u_typ.includes("company")
      );
    }
  }
  get visaDates() {
    return this.visaForm.get("dates") as FormArray;
  }
  get youngVisaDates() {
    return this.youngVisaForm.get("dates") as FormArray;
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(
      this.youngVisaForm,
      controlName,
      validationType
    );
  }
  addVisaDates(element?: any) {
    const datesForm = this.fb.group({
      st_dt: [element ? element?.st_dt : "", Validators.required],
      ed_dt: [element ? element?.ed_dt : "", Validators.required],
      id: [element ? element?.id : "",],

      permitted_hour: [
        element ? element?.permitted_hour : "",
        [Validators.required, PositiveNumber],
      ],
    });
    this.visaDates.push(datesForm);
  }
  removeVisaDates(index: number) {
    this.visaDates.removeAt(index);
  }
  addYoungVisaDates(element?: any) {
    // formatting start/end time to "h:mm" because it's "11:00:00" format from API and it cannot patch with form.
    let startTime = new Date();
    let endTime = new Date();
    if (element) {
      startTime.setHours(element?.st_ti?.split(":")[0]);
      startTime.setMinutes(element?.st_ti?.split(":")[1]);

      endTime.setHours(element?.ed_ti?.split(":")[0]);
      endTime.setMinutes(element?.ed_ti?.split(":")[1]);
    }
    const datesForm = this.fb.group({
      st_dt: [element ? element?.st_dt : "", Validators.required],
      ed_dt: [element ? element?.ed_dt : "", Validators.required],
      id: [element ? element?.id : ""],
      permitted_hour: [
        element ? element?.permitted_hour : "",
        [Validators.required, PositiveNumber],
      ],
      st_ti: [
        element ? this.datePipe.transform(startTime, "h:mm") : "",
        Validators.required,
      ],
      ed_ti: [
        element ? this.datePipe.transform(endTime, "h:mm") : "",
        Validators.required,
      ],
    });
    this.youngVisaDates.push(datesForm);
  }
  removeDates(index: number) {
    this.youngVisaDates.removeAt(index);
  }
  onSelectedSettings(item) {
    this.selectedSetting = item;

    if (this.selectedSetting.id == 2) {
      this.wageType = WageType.defaultCompany;
    } else {
      this.wageType = WageType.defaultEmployee;
    }


    if (this.selectedSetting.id == 5) {
      this.getDressCode()
    }
    if (item.name == "Visa") {
      this.getVisaAPI();
    } else if (item.name == "Premium Time") {
      this.getSettings();
    } else {
      this.getCategoryList();
    }
  }
  onDeleteItem(item) {
    this.visaDateArr.splice(item, 1);
  }
  onAddNewDate() {
    this.visaDateArr.push({ d_h: "", s_dt: "", e_dt: "" });
  }
  onSubmitYoungVisa() {

    if (this.visaForm.invalid) {
      this.visaForm.markAllAsTouched();
    }
    if (this.youngVisaForm.invalid) {
      this.youngVisaForm.markAllAsTouched();
    } else {
      let objReq = this.youngVisaForm.value;
      let newArr = [...objReq.dates];
      newArr.map((item) => {
        item["st_dt"] = this.datePipe.transform(item["st_dt"], "yyyy-MM-dd");
        item["ed_dt"] = this.datePipe.transform(item["ed_dt"], "yyyy-MM-dd");
        // item["id"] = this.condIds0;
        item["id"] = item['id'];
      });
      objReq.dates = newArr;

      let newVisaDateArr = this.visaForm.get("dates")?.value;

      newVisaDateArr.map((item) => {
        item["st_dt"] = this.datePipe.transform(item["st_dt"], "yyyy-MM-dd");
        item["ed_dt"] = this.datePipe.transform(item["ed_dt"], "yyyy-MM-dd");
        item["id"] = item['id'];
        // item["id"] = this.condIds1;
        item["st_ti"] = "";
        item["ed_ti"] = "";
      });
      let sendReq = {};
      sendReq["v_d"] = [
        {
          id: this.ids1,
          d_h: this.visaForm.get("d_h")?.value,
          age: "",
          u_t: "1", //for the manage legal compliance
          cond: newVisaDateArr,
        },
        {
          id: this.ids0,
          d_h: this.youngVisaForm.get("d_h")?.value,
          u_t: "0", //for young worker's rules pass 1
          age: this.youngVisaForm.get("age")?.value,
          cond: newArr,
        },
      ];
      this.callVisaAPI(sendReq);
    }
  }
  onSubmitVisa() {

    if (this.visaForm.invalid) {
      this.visaForm.markAllAsTouched();
    } else {
    }
  }

  callVisaAPI(data) {
    this.recruiterService.addVisaRule(data).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.appService.showToastMessage("success", success.msg);
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  getVisaAPI() {
    var data = {};

    this.recruiterService.getVisaRule(data).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          // this.appService.showToastMessage('success', success.msg)

          success.msg.forEach((item) => {
            if (item.u_t === 1) {
              this.ids1 = item.id;
              // setTimeout(()=>{
              //   this.visaForm.get('dates')?.setValue(item.cond);
              // },2000)
              this.visaForm.get("d_h")?.setValue(item.permitted_hour);
              if (item?.cond?.length > 0) {
                this.visaDates.clear();
                item?.cond?.forEach((element) => {
                  this.addVisaDates(element);
                });
              }
            } else if (item.u_t === 0) {
              this.ids0 = item.id;
              this.youngVisaForm.get("d_h")?.setValue(item?.permitted_hour);
              this.youngVisaForm.get("age")?.setValue(item?.age);
              if (item?.cond?.length > 0) {
                this.youngVisaDates.clear();
                item?.cond?.forEach((element) => {
                  this.addYoungVisaDates(element);
                });
              }
            }

            if (item.cond.length > 0) {
              item.cond.forEach((condItem) => {
                this.condIds1 = condItem.id;
                if (condItem.u_t === 1) {
                } else if (condItem.u_t === 0) {
                  this.condIds0 = condItem.id;
                }
              });
            }
          });

        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement;
    this.config.itemsPerPage = Number(tar.value);
    this.config.currentPage = 1;
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == "" && this.previousInputValue !== "") {
      this.config.currentPage = 0;
    }
  }
  getCategoryList() {
    let objReq = {
      jc_id: "",
      em_i: "",
      co_i: "",
      w_t: this.wageType,
    };
    this.dataSource = new MatTableDataSource();
    this.recruiterService.getJobCategories(objReq).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.dataSource = new MatTableDataSource(success.msg);
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onAddEditCat(type, item) {
    let objData = {};
    objData["wages_type"] = this.wageType;

    if (type == "edit") {
      objData["category_data"] = item;
    }
    const dialogRef = this.dialog.open(AddCategoryComponent, {
      width: "70%",
      minWidth: "300px",
      maxWidth: "750px",
      height: "98%",
      maxHeight: "680px",
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      // minHeight:'200px'
      data: objData,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result["data_added"] == true) {
          this.getCategoryList();
        }
      }
    });
  }

  onViewCompanyRates() {
  }
  onDeleteCompanyRate(id) {
    let objData = {
      api_type: "delete_content",
      content_type: "delete_company_category",
      id: id,
      wages_type: this.wageType,
    };
    const dialogRef = this.dialog.open(
      DeleteItemComponent,
      Object.assign({
        data: objData,
      })
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result["delete_content"] == true) {
        this.getCategoryList();
      }
    });
  }
  submitVisaRule() {
    let objReq = {
      w_t: this.wageType,
      jc_id: "",
      em_i: "",
      co_i: "",
    };

    this.recruiterService.addVisaRule(objReq).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.dataSource = new MatTableDataSource(success.msg);
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onSelectDay(setting, item: any) {
    const days = this.timeSetting[setting]["selectedMonth"];
    const index = days.indexOf(item.val);
    if (index > -1) {
      days.splice(index, 1);
    } else {
      days.push(item.val);
    }
  }
  checkSelectedDay(settingType: string, value) {
    if (!this.timeSetting[settingType].selectedMonth) {
      this.timeSetting[settingType].selectedMonth = [];
    }
    return this.timeSetting[settingType].selectedMonth.includes(value);
  }


  onSavePremiumTime() {
    this.callApi(this.generalObj)
  }
  callApi(obj) {
    obj["r_type"] = "2";
    obj["u_t"] = "1";
    obj["u_id"] = []; //ankush

    obj["reminder_active_on"] = this.getRemArray(this.remDays)
    obj["work_days_length_limit"] = this.transformedArray(this.workdays, 'general')

    for (let i = 0; i < this.limitationArr.length; i++) {
      if (this.limitationArr[i]["selected"] == true) {
        const { key, val, ...remainingProperties } = this.limitationArr[i];   // Remove unwanted keys from the original object
        const limitObj = { [key]: remainingProperties };        // Create a new object with the remaining properties
        Object.assign(obj, limitObj);
      }
    }
    if (this.breakType == "disable_breaks") {
      obj["disable_breaks"] = { "yes_no": "1", selected: true },
        delete obj["automatic_breaks"]
      delete obj["manual_breaks"]
    }
    else if (this.breakType == "manual_breaks") {
      obj["manual_breaks"] = { "yes_no": "1", selected: true },
        delete obj["automatic_breaks"]
      delete obj["disable_breaks"]
    }
    else {
      obj["automatic_breaks"] = this.automaticArr
      delete obj["manual_breaks"]
      delete obj["disable_breaks"]
    }

    this.rulesService.submitRules(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
          // this.dialogRef.close()
        }
      },
      error: (error: any) => {
        this.commonservice.handleError(error);
      }
    })
  }

  getSelectedDays(type: any, val: any) {
    if (this.overtimeWeekDays[type].includes(val)) {
      return true;
    }
    return false;
  }

  onAddDaysOvertime(type: any, val: any) {
    let newArr = this.overtimeWeekDays[type];


    if (newArr.includes(val.value)) {
      newArr.splice(newArr.indexOf(val.value), 1);
    }
    else {
      newArr.push(val.value);
    }
    if (this.generalObj[type].hasOwnProperty(val.value)) {

      delete this.generalObj[type][val.value];
    }
    else {
      const obj = {};
      obj[val.value] = "1";
      this.generalObj[type] = Object.assign(this.generalObj[type], obj);
    }
  }
  getRemArray(array: any[]) {
    const transformedObject: any = {};
    array.forEach(item => {
      if (item.selected == true) {
        transformedObject[item.value] = "1";
      }
      else {
        transformedObject[item.value] = "0";
      }
    });
    return transformedObject;
  }

  transformedArray(array: any[], type: string) {
    const transformedObject: any = {};
    array.forEach(item => {
      if (item.selected == true) {
        if ((item.hours == "" || item.hours == null)) { item.hours = "8" }
        transformedObject[item.value] = item.hours;
      }
      else {
        transformedObject[item.value] = "";
      }
      // newWorkDaysArr.push(transformedObject)// Assign "10" to each key
    });
    return transformedObject;
  }

  getSettings() {
    const obj = {
      "r_type": "2",
      // "co_i" : "",
      // "em_i": "",
      "u_t": "1",
    }

    this.rulesService.getRules(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          let data = success.msg;
          for (let [key, val] of Object.entries(data)) {
            if (key in this.generalObj) {
              this.generalObj[key] = val;
              if (key == "reminder_active_on") {
                for (let i = 0; i < this.remDays.length; i++) {
                  if (this.generalObj[key][this.remDays[i].value] == "1") {
                    this.remDays[i]["selected"] = true
                  }
                }
              }
              for (let i = 0; i < this.limitationArr.length; i++) {
                const keyValue = this.limitationArr[i].key;
                if (this.generalObj.hasOwnProperty(keyValue)) {
                  this.limitationArr[i]["fr"] = this.generalObj[keyValue]["fr"];
                  this.limitationArr[i]["to"] = this.generalObj[keyValue]["to"];
                  this.limitationArr[i]["selected"] = this.generalObj[keyValue]["selected"]
                }
              }
            }
            this.automaticArr = [];
            if (data.hasOwnProperty('work_days_length_limit')) {
              this.setSettings(data["work_days_length_limit"])
            }
            if (data.hasOwnProperty('disable_breaks')) { this.breakType = "disable_breaks" }
            if (data.hasOwnProperty('manual_breaks')) { this.breakType = "manual_breaks" }
            if (data.hasOwnProperty('automatic_breaks')) {
              this.breakType = "automatic_breaks"
              this.automaticArr = data["automatic_breaks"]
            }
            //daily,partial and consecutive overtimes are selected then below function is logic to set the selected week days



          }

          this.setSelectedWorkdays(data, 'daily_overtime')
          this.setSelectedWorkdays(data, 'partial_day_overtime')
          this.setSelectedWorkdays(data, 'premium_time')
          this.setSelectedWorkdays(data, 'consecutive_days_overtime')
        }

        // this.dialogRef.close()
      },
      error: (error: any) => {
        //this.isSpinnerLoading = false
        this.commonservice.handleError(error);
      }
    })
  }


  setSelectedWorkdays(data, node_name) {
    const newArr = ['sun', 'mon', 'tues', 'wed', 'thur', 'fri', 'sat']
    if (data.hasOwnProperty(node_name)) {
      for (let key of Object.keys(data[node_name])) {
        if (newArr.includes(key)) {
          this.overtimeWeekDays[node_name].push(key)
        }
      }
    }
  }

  setSettings(obj) {
    this.workdays = this.workdays.map(day => {
      if (obj.hasOwnProperty(day.value)) {
        const hours = obj[day.value];
        return {
          ...day,
          selected: hours !== "" && hours !== null,
          hours: hours !== "" ? String(hours) : day.hours
        };
      }
      return day;
    });
  }

  onAddEditDress(type, item) {
    let objData = {};

    if (type == "edit") {
      objData["category_data"] = item;
    }
    const dialogRef = this.dialog.open(CreateDressCodeComponent, {
      width: "70%",
      minWidth: "300px",
      maxWidth: "750px",
      height: "98%",
      maxHeight: "680px",
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      // minHeight:'200px'
      data: objData,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getDressCode();
    });
  }

  getDressCode() {
    let objReq = {
      em_i: "",
      st_dt: '',
      ed_dt: '',
      sh: this.filterObjData.dresscode.sh,
      st: this.appService.startPageLogic(
        this.filterObjData.dresscode.currentPage,
        this.filterObjData.dresscode.itemsPerPage
      ),
      r_p: this.filterObjData.dresscode.itemsPerPage,
    };
    this.filterObjData.dresscode.previousInputValue = this.filterObjData.dresscode.sh;
    this.recruiterService.getDressCode(objReq).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.filterObjData.dresscode.count = success.count;
          this.dressCode = new MatTableDataSource(success.msg);
        }
      },
      error: (error: any) => {
      },
    });
  }

  onDeleteLogo(id) {
    let objData = {
      api_type: "delete_content",
      content_type: "delete_dress_code",
      id: id,
    };
    const dialogRef = this.dialog.open(
      DeleteItemComponent,
      Object.assign({
        data: objData,
      })
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result["delete_content"] == true) {
        this.getDressCode();
      }
    });
  }


  onSearchMult(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == "" && this.filterObjData[type].previousInputValue !== "") {

      if (type == "dress") {
        this.getDressCode()
      } else {
        // this.onTabAPICall(type);
      }

    }
  }

  onGo(type: string) {
    this.getDressCode()
  }


  onPageSizeChangeMult(event: Event, type: string) {
    const tar = event.target as HTMLInputElement;
    this.filterObjData[type].itemsPerPage = Number(tar.value);
    this.filterObjData[type].currentPage = 1;
    this.onTabAPICall(type);
  }

  onPageChangeMult(number: number, type: string) {

    this.filterObjData[type].currentPage = number;
    this.onTabAPICall(type);
  }


  onTabAPICall(type) {
    if (type == "dress") {
      this.getDressCode();
    }
  }

}
